import user from "./user";
import im from './im'

export default {
  user,
  im
};
